<template>
    <div class="components-page-header">
        <div class="page-header-inner" :class="{ 'layout-container': !fullWidth, fullWidth: fullWidth }">
            <div class="inline-block logo-wrapper">
                <img class="cursor-pointer" src="../common/images/logo.jpg" alt="" />
                <slot name="left-slot"></slot>
            </div>
            <div class="header-center-wrapper">
                <el-menu :default-active="$route.path" router mode="horizontal">
                    <el-menu-item index="/home/page-list">
                        <i class="el-icon-mobile"></i>
                        <span slot="title">节目管理</span>
                    </el-menu-item>
                    <el-menu-item index="/home/device-manager">
                        <i class="el-icon-monitor"></i>
                        <span slot="title">设备管理</span>
                    </el-menu-item>
                    <el-menu-item index="/home/explorer">
                        <i class="el-icon-folder"></i>
                        <span slot="title">资源管理</span>
                    </el-menu-item>


                    <!-- <el-menu-item index="/home/page-data">
                        <i class="el-icon-menu"></i>
                        <span slot="title">数据统计</span>
                    </el-menu-item> -->

                    <el-menu-item index="/home/setting">
                        <i class="el-icon-setting"></i>
                        <span slot="title">系统管理</span>
                    </el-menu-item>

                </el-menu>
                <slot></slot>
            </div>
            <div class="user-wrapper">
                <slot name="right-slot"></slot>
                <!-- <userHeadBtn /> -->

                <cost></cost>
                <el-button type="text" slot="reference" @click="refreshLogin">
                    刷新登录
                    <i class="el-icon-refresh"></i>
                </el-button>
            </div>
        </div>

        <div class="jdc-side">
            <div class="mod_hang_qrcode" @mouseover="clearHover" v-if="steps">
                <div class="mod_hang_appeal_btn" @click="showDeviceHelpDialog=true">
                    <i class="el-icon-monitor"></i>
                    <span style="font-size: 10px;">设备绑定</span>
                </div>
            </div>

            <div class="mod_hang_qrcode"  @mouseover="mouseover"  @mouseout="mouseout" v-if="rightMenus&&rightMenus.links && rightMenus.links.length > 0">
                <div class="mod_hang_appeal_btn">
                    <i class="el-icon-help"></i>
                    <span style="font-size: 10px;">帮助手册</span>
                </div>
                <div class="mod_hang_appeal_show" :style="{display: hover ? 'block' : 'none'}" @mouseover="mouseover"  @mouseout="mouseout2">
                    <ul v-if="rightMenus">
                        <li v-for="(one, index) in rightMenus.links" :key="index">
                            <a :href="one.link" target="_blank">
                                <div class="icon_box">
                                    <!-- <i class="jdcfont"></i> -->
                                </div>
                                <div class="text_box">
                                    <h5>{{ one.title }}</h5>
                                    <p>{{ one.tips }}</p>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>


            <div class="mod_hang_qrcode" @mouseover="clearHover" v-if="rightMenus&&rightMenus.qrcode">
                <a class="mod_hang_appeal_btn">
                    <i class="el-icon-user"></i>
                    <span style="font-size: 10px;">人工客服</span>
                </a>
                <div class="mod_hang_qrcode_show">
                    <div class="mod_hang_qrcode_show_bg">
                        <el-image :src="rightMenus.qrcode"></el-image>
                    </div>
                    <p>联系人工客服</p>
                </div>
            </div>

        </div>

        <el-dialog
            title="设备绑定指南" destroy-on-close	lock-scroll	modal-append-to-body	append-to-body	
            :visible.sync="showDeviceHelpDialog" custom-class="this-dialog"
            width="1000px">

            <div style="    background-color: #FAFAFA;
                        margin: -20px;
                        margin-top: -20px;
                        margin-bottom: -30px;
                    ;">
                <div style="height:500px;padding: 20px;height: 500px;padding: 20px;display: flex;width: 100%;justify-content: space-between;">
                    <div style="background-color: white;height:100%;width: 32%;" v-for="(step, index) in steps" :key="index">
                        <div style="height: 280px;margin-top: 70px;">
                            <el-image :src="step.image_url"></el-image>
                        </div>
                        <div style="margin: 50px 50px 0 50px;color: #626262;line-height: 1.6;text-align: left;">
                            {{step.title}}
                        </div>
                        <div style="margin: 0 50px;font-size: 14px;color: #B3B3B3;text-align: left;">
                            <a :href="step.link" target="_blank" style="color: #3E9BF6;cursor: pointer;">{{step.sub_title}}</a>
                        </div>                    
                    </div>
                </div>
            </div>

        </el-dialog>

    </div>

</template>

<script>
import cost from "./cost/cost.vue"
export default {
    props: {
        fullWidth: {
            type: Boolean,
            default: true
        }
    },
    components: {
        cost
    },
    data() {
        return {
            activeStep: 0,
            showDeviceHelpDialog: false,
            rightMenus: null,
            steps: null,
            hover: false,
            hoverTimer: null
        }
    },
    mounted() {
        this.loadHelpMenus();
    },
    methods: {
        refreshLogin() {
            delete localStorage.jwtToken;
            window.location.reload();
        },
        clearHover() {
            console.log('clearHover');
            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = null;
            }

            this.hover = false;

        },
        mouseover() {
            console.log('mouseover');
            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = null;
            }

            this.hover = true;

        },
        mouseout() {
            let _this = this;
            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = null;
            }

            this.hoverTimer = setTimeout(function() {
                if (_this.hoverTimer) {
                    _this.hover = false;
                    _this.hoverTimer = null;
                    console.log('mouseout');
                }
            }, 500);

            
        },
        mouseout2() {
            console.log('mouseout2');

            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = null;
            }

            this.hover = false;
        },
        loadHelpMenus() {
            this.$API.loadHelpMenus({}).then((response) => {
                if (response.code == 0 || response.code == 1000) {
                    this.rightMenus = response.data.menus;
                    this.steps = response.data.steps;
                }
            });
        },
        // goHome() {
        //   // 已登录就去工作台，
        //   // 没登陆就去首页
        //   if (this.$store.state.user.access_token) {
        //     this.$router.push({ name: "Home" });
        //   } else {
        //     this.$router.push({ name: "Home" });
        //   }
        // },
    },
};
</script>

<style lang="scss" scoped>
.components-page-header {
    height: 100%;
    background: white;
    box-shadow: 0 2px 6px 6px rgba(100, 100, 100, 0.3);
    min-height: 60px;
}

.page-header-inner {
    display: flex;

    &.fullWidth {
        padding: 0 18px;
    }
}

.logo-wrapper {
    width: 160px;
    font-size: 18px;
    line-height: 60px;

    img {
        display: inline-block;
        height: 50px;
        vertical-align: middle;
    }

    span {
        display: inline-block;
        vertical-align: middle;
    }
}

.header-center-wrapper {
    flex: 1;
    text-align: center;

    // ::v-deep .el-menu--horizontal{
    //   display:flex;
    //   flex-wrap: now;
    // }
}

.user-wrapper {
    width: 160px;
    text-align: right;
    padding-top: 6px;
    line-height: 40px;

}

</style>


<style lang="css" scoped>
.jdc-side {
    position: fixed;
    top: calc(50vh);
    right: 15px;
    z-index: 300;
    width: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.mod_hang_qrcode {
    position: relative
}

.mod_hang_qrcode_show {
    display: none;
    position: absolute;
    right: 60px;
    bottom: 0px;
    width: 138px;
    min-height: 166px;
    border: 0 none;
    background: #fff;
    -webkit-box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    -moz-box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1)
}

.mod_hang_qrcode_show p {
    margin-top: 5px;
    line-height: 16px;
    color: #666;
    font-size: 12px;
    text-align: center
}

.mod_hang_qrcode:hover .mod_hang_qrcode_show {
    display: block
}

.mod_hang_appeal_btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50px;
    height: 60px;
    color: #25a589;
    background-color: #FFFFFF;
    text-align: center;
    font-size: 30px;
    cursor: pointer;
    -webkit-box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    -moz-box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
}

.mod_hang_appeal_btn:hover {
    color: #FFFFFF;
    background-color: #25a589;
}


.mod_hang_appeal_show {
    /* opacity: 1;
    z-index: -9;
    right: -500px; */
    position: absolute;
    right: 60px;
    top: 0px;
    background: #fff;
    -webkit-box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    -moz-box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    box-shadow: 0 0 10px 0 rgba(20, 34, 67, .1);
    width: 150px;
}

.mod_hang_appeal_show li {
    *zoom: 1;
    cursor: pointer
}

.mod_hang_appeal_show li:hover {
    background: #f3f5fb
}

.mod_hang_appeal_show li:after,
.mod_hang_appeal_show li:before {
    content: "";
    display: block;
    clear: both;
    height: 0;
    line-height: 0;
    visibility: hidden
}

.mod_hang_appeal_show .icon_box,
.mod_hang_appeal_show .text_box {
    float: left;
    width: 130px;
    height: 70px;
    cursor: pointer
}

.mod_hang_appeal_show .icon_box {
    width: 10px;
    line-height: 90px;
    text-align: center
}

.mod_hang_appeal_show .icon_box i {
    color: #0989c5;
    font-size: 30px
}

.mod_hang_appeal_show .text_box h5 {
    margin-top: 10px;
    font-size: 16px;
    color: #03004c;
    line-height: 24px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
}

.mod_hang_appeal_show .text_box p {
    margin-top: 10px;
    max-height: 36px;
    overflow: hidden;
    line-height: 18px;
    font-size: 12px;
    color: #666;
    cursor: pointer
}
</style>

